import request from '@/utils/request'

/**
* 文件处理
*
* @author ljw
*/


/**
* 基础接口
*
* @type {string}
*/
const BASE_URL = '/manage/upfile'

export const DOME_BASE_URL = BASE_URL


/**
* 上传文件,返回文件名称
*
* @param data 文件formdata
* @returns {Promise}
*/
export function uploadFileForName(data: any) {
  return request({
    url: `${BASE_URL}/upload/`,
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}